import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    orderId: String,
    amount: String,
    items: Array,
  };

  initialize() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "purchase",
      ecommerce: {
        currency: "JPY",
        transaction_id: this.orderIdValue,
        value: this.amountValue,
        items: this.itemsValue,
      },
    });
  }
}
